var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry"},[_c('div',{staticClass:"main clearfix"},[_c('SiteSide'),_c('div',{staticClass:"right"},[_c('SiteHeader'),_c('div',{staticClass:"content"},[_c('router-view')],1)],1)],1),(_vm.userInfo.identity !== 0 && !['signIn', 'signUp', 'findPass'].includes(_vm.routeName))?_c('PublicNotify'):_vm._e(),_c('PublicAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }